// Router Push 错误抑制插件
// 迁移自 router/index.js : VueRouterPush 重写
// 解决重复点击当前路由导致的 Uncaught (in promise) 错误

import VueRouter from 'vue-router'

// 直接修改 VueRouter 原型方法，确保在所有 router 实例创建之前生效
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
